import React, { useEffect, useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import {
  HonPrimeMinisterCanada,
  CouncillorMarkham,
  MarkCarneyRajanSharma2,
  MarkCarneyRajanSharma3,
  MarkCarneyRajanSharma4,
  MarkCarneyRajanSharma5,
  IndoCanadachamber,
  RajanSharmaHodgson
} from './imports';
import './recognitions.css';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    slidesToSlide: 1
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slidesToSlide: 1
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1
  }
};

const leadershipSlides = [

  {
    type: 'image',
    image: MarkCarneyRajanSharma2,
    alt: 'Rajan Sharma with Mark Carney recognition moment two',
    title: 'Leadership Meet - Moment 2',
    description: 'An inspiring exchange with the PM of Canada reflecting the growing visibility of South Asian musical excellence.'
  },
  {
    type: 'image',
    image: MarkCarneyRajanSharma3,
    alt: 'Rajan Sharma with Mark Carney recognition moment three',
    title: 'Leadership Meet - Moment 3',
    description: 'Another milestone from the event that underlines the journey of Bollywood Ki Dhun.'
  },
  {
    type: 'image',
    image: MarkCarneyRajanSharma4,
    alt: 'Rajan Sharma with Mark Carney recognition moment four',
    title: 'Leadership Meet - Moment 4',
    description: 'A proud frame from the gathering celebrating community-driven arts and performance platforms.'
  },
  {
    type: 'image',
    image: MarkCarneyRajanSharma5,
    alt: 'Rajan Sharma with Mark Carney recognition moment five',
    title: 'Leadership Meet - Moment 5',
    description: 'A final featured moment that reflects recognition, encouragement, and continued cultural impact.'
  },
  {
    type: 'image',
    image: RajanSharmaHodgson,
    alt: 'Rajan Sharma with Tim Hodgson recognition moment five',
    title: 'Leadership Meet - Moment 6',
    description: 'With minister Tim Hodgson that reflects recognition, encouragement, and continued cultural impact.'
  },
  
  {
    type: 'image',
    image: IndoCanadachamber,
    alt: 'Recognition from Indo Canada Chamber',
    title: 'Indo-Canada Chamber Spotlight',
    description: 'At the Arya Samaj, Markham with Prashant Srivastava, President and Kam Rathee, Advisory Chair Indo-Canada Chamber of Commerce'
  }
];

const recognitionSlides = [
  {
    type: 'image',
    image: HonPrimeMinisterCanada,
    alt: 'Recognition from the Hon. Prime Minister of Canada',
    title: 'National Appreciation',
    description: 'A recognition that celebrates the team’s commitment to uplifting South Asian musical talent across North America.'
  },
  {
    type: 'image',
    image: CouncillorMarkham,
    alt: 'Recognition from Councillor Markham',
    title: 'City-Level Honor',
    description: 'A meaningful acknowledgment from municipal leadership for consistent artistic and community contribution.'
  },
  {
    type: 'video',
    videoUrl: 'https://www.youtube.com/embed/kC3SHzLUcys',
    title: 'Recognition Video - Feature 1',
    description: 'A featured video highlight capturing one of Bollywood Ki Dhun\'s recognition moments.'
  },
  {
    type: 'video',
    videoUrl: 'https://www.youtube.com/embed/HTVffcTeVsU',
    title: 'Recognition Video - Feature 2',
    description: 'A second recognition video showcasing the organization\'s community presence and impact.'
  }
];

const renderSlides = (slides, setActiveSlide) => (
  <Carousel
    responsive={responsive}
    arrows={true}
    showDots={true}
    infinite={true}
    swipeable={true}
    draggable={true}
    keyBoardControl={true}
    transitionDuration={500}
    containerClass="recognitions-carousel"
    dotListClass="recognitions-dot-list"
    itemClass="recognitions-item"
  >
    {slides.map((slide) => (
      <article className="recognitions-slide" key={slide.title}>
        <div className="gpt3__recognitionImage-image">
          {slide.type === 'video' ? (
            <div className="recognitions-video-frame">
              <iframe
                src={slide.videoUrl}
                title={slide.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
          ) : (
            <button
              type="button"
              className="recognitions-image-button"
              onClick={() => setActiveSlide(slide)}
              aria-label={`Open larger view of ${slide.title}`}
            >
              <img src={slide.image} alt={slide.alt} />
            </button>
          )}
        </div>
        <div className="recognitions-caption">
          <h3>{slide.title}</h3>
          <p>{slide.description}</p>
        </div>
      </article>
    ))}
  </Carousel>
);

const Recognitions = () => {
  const [activeSlide, setActiveSlide] = useState(null);

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        setActiveSlide(null);
      }
    };

    if (activeSlide) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleEsc);
    }

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleEsc);
    };
  }, [activeSlide]);

  return (
    <div className='gpt3__recognitions' id="recognitions">
      <div className="recognitions-group">
        <h1 className="gradient__text">Leadership</h1>
        <div className='gpt3__recognitions-container'>
          {renderSlides(leadershipSlides, setActiveSlide)}
        </div>
      </div>

      <div className="recognitions-group">
        <h1 className="gradient__text">Recognition</h1>
        <div className='gpt3__recognitions-container'>
          {renderSlides(recognitionSlides, setActiveSlide)}
        </div>
      </div>

      {activeSlide && (
        <div
          className="recognitions-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label={activeSlide.title}
          onClick={() => setActiveSlide(null)}
        >
          <div className="recognitions-lightbox-content" onClick={(event) => event.stopPropagation()}>
            <button
              type="button"
              className="recognitions-lightbox-close"
              onClick={() => setActiveSlide(null)}
              aria-label="Close image popup"
            >
              x
            </button>
            <img src={activeSlide.image} alt={activeSlide.alt} />
            <div className="recognitions-lightbox-caption">
              <h3>{activeSlide.title}</h3>
              <p>{activeSlide.description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Recognitions;
